import { render, staticRenderFns } from "./AboutMeSection.vue?vue&type=template&id=3203f4e0&scoped=true"
var script = {}
import style0 from "./AboutMeSection.vue?vue&type=style&index=0&id=3203f4e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3203f4e0",
  null
  
)

export default component.exports